/**
 * Schoorsteenveger Queries
 * Dunne wrappers rond de backend-API (/api/schoorsteenveger/*) met een
 * Bearer-JWT. De aggregatie (employee/service breakdown, trends, etc.)
 * gebeurt server-side. Export-namen en return-shapes zijn behouden.
 */

import { apiGet } from './apiClient';

// Bouw de query-params op uit de filters (period | startDate+endDate).
const buildParams = (filters = {}) => {
  const params = {};
  if (filters.period) params.period = filters.period;
  if (filters.startDate) params.startDate = filters.startDate;
  if (filters.endDate) params.endDate = filters.endDate;
  return params;
};

// Get current month revenue -> { count, totalRevenue }
export const getCurrentMonthRevenue = async (filters = {}) => {
  try {
    const res = await apiGet('/schoorsteenveger/revenue', buildParams(filters));
    return { count: res.count || 0, totalRevenue: res.totalRevenue || 0 };
  } catch (error) {
    console.error('Error fetching current month revenue:', error);
    throw error;
  }
};

// Get current month invoice count -> number
export const getCurrentMonthInvoiceCount = async (filters = {}) => {
  try {
    const res = await apiGet('/schoorsteenveger/invoice-count', buildParams(filters));
    return res.count || 0;
  } catch (error) {
    console.error('Error fetching invoice count:', error);
    throw error;
  }
};

// Get revenue per employee -> [...]
export const getRevenuePerEmployee = async (filters = {}) => {
  try {
    return await apiGet('/schoorsteenveger/revenue-per-employee', buildParams(filters));
  } catch (error) {
    console.error('Error fetching revenue per employee:', error);
    throw error;
  }
};

// Get revenue per service -> [...]
export const getRevenuePerService = async (filters = {}) => {
  try {
    return await apiGet('/schoorsteenveger/revenue-per-service', buildParams(filters));
  } catch (error) {
    console.error('Error fetching revenue per service:', error);
    throw error;
  }
};

// Get outstanding invoices -> [...]
export const getOutstandingInvoices = async (filters = {}) => {
  try {
    return await apiGet('/schoorsteenveger/outstanding', buildParams(filters));
  } catch (error) {
    console.error('Error fetching outstanding invoices:', error);
    throw error;
  }
};

// Get monthly revenue trend -> [...]
export const getMonthlyRevenueTrend = async (filters = {}) => {
  try {
    return await apiGet('/schoorsteenveger/monthly-trend', buildParams(filters));
  } catch (error) {
    console.error('Error fetching monthly revenue trend:', error);
    throw error;
  }
};

// Get all dashboard data (server aggregeert in één call)
export const getAllDashboardData = async (filters = {}) => {
  try {
    return await apiGet('/schoorsteenveger/all', buildParams(filters));
  } catch (error) {
    console.error('Error fetching all dashboard data:', error);
    throw error;
  }
};
